import styled from "styled-components";

const StyledGridContainer = styled.div`
    display: grid;
    grid-template-columns: ${({ gridTemplate, count }) => gridTemplate ? gridTemplate : `repeat(${count}, 1fr)`};
    padding: 0 1rem 0 0;
    color: var(--sp-text-color);

    & > div:nth-child(-n + ${({ count }) => count}) {
        border-bottom: 1px dashed;
    }

    & > div:not(last-child) {
        margin-bottom: 8px;
    }
`;

const StyledGridItem = styled.div`
    grid-column: ${({ index }) => index};
`

export const Grid = ({ count=1, children, ...props}) => {
    let index = 0;
    return(
        <StyledGridContainer count={count} {...props}>
            {Array.isArray(children)
                ? children.map((cell, idx) => {
                    index = index >= count ? 1 : index++;
                    return(
                        <StyledGridItem key={`grid-cell-${idx}`} index={index}>{cell}</StyledGridItem>
                    )
                })
                : null}
        </StyledGridContainer>
    )
}